module.exports = __webpack_public_path__ + "img/r_rendering_icon_07.309195e9.png";